module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_vm._v("Don’t miss any books in this thrilling new series:")])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_c('em', [_vm._v("FEARLESS")]), _vm._v(" ™")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("#1 Fearless")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("#2 Sam")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("#3 Run")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("#4 Twisted")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("#5 Kiss")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("#6 Payback")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("#7 Rebel")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("#8 Heat")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("#9 Blood")]), _vm._v(" "), _c('p', {
    staticClass: "centerab"
  }, [_vm._v("Available from POCKET PULSE")]), _vm._v(" "), _c('div', {
    staticClass: "sideber1"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("For orders other than by individual consumers, Pocket Books grants a discount on the purchase of "), _c('strong', [_vm._v("10 or more")]), _vm._v(" copies of single titles for special markets or premium use. For further details, please write to the Vice-President of Special Markets, Pocket Books, 1260 Avenue of the Americas, New York, NY 10020–1586, 8th Floor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("For information on how individual consumers can place orders, please write to Mail Order Department, Simon & Schuster Inc., 100 Front Street, Riverside, NJ 08075.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bf2396a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 63
// module chunks = 0